import $ from 'jquery';

const page = $(document);

page.on('click tap mouseenter', '[data-trigger]', function (e) {
  const element = $(e.currentTarget || e.target);
  const notify = $(`#${element.data('notify')}`);

  // find hidden images inside of the container and set their src and srcset
  notify.find('img.hidden').each(function (idx, imgEl): void {
    const img = $(imgEl);
    const data = img.data();
    img.attr('src', data.src);
    img.attr('srcset', data.srcset);
    img.removeClass('hidden');
  });
});

page.on('click tap', '[data-trigger]', function (e) {
  const element = $(e.currentTarget || e.target);
  const action = $(`#${element.data('trigger')}`);
  const notify = $(`#${element.data('notify')}`);
  element.toggleClass('active');
  const active = element.hasClass('active');
  notify.toggleClass('active', active);
  const groupId = element.data('group');

  if (groupId) {
    const group = $(`[data-group=${groupId}]`);
    group.each(function (i, node): void {
      //close all elements in the same group
      const content = $(node);
      if (node !== element.get(0) && content.hasClass('active') && active) {
        content.trigger('click');
      }
    });
  }

  if (
    element.data('animation') === 'none' ||
    $(document.body).hasClass('test')
  ) {
    action.toggle();
  } else {
    action.slideToggle();
  }
});

page.on('click tap', '.js-conditional-submit', function (e) {
  e.preventDefault();
  const element = $(e.target);
  const sameGroupId = element.data('same-group');
  if ($(`[data-same-group='${sameGroupId}']:checked`).length === 0) {
    const fallbackTargetId = element.data('fallback-target');
    $(fallbackTargetId).trigger('click');
  }
  $(this).trigger('submit');
});

page.on('change', '.js-exclusive-check', function (e) {
  const element = $(e.target);
  const sameGroupId = element.data('same-group');
  $('.js-exclusive-check')
    .not(`[data-same-group='${sameGroupId}']`)
    .prop('checked', false);
});

function jsRewriteTextCheck(enablingTargetId: string): void {
  if ($(`[data-conditional-text='${enablingTargetId}']:checked`).length > 0) {
    const conditionalText = $(enablingTargetId).data('conditional-text');
    $(enablingTargetId).val(conditionalText);
    $(enablingTargetId).addClass('highlight');
  } else {
    const originalText = $(enablingTargetId).data('original-text');
    $(enablingTargetId).val(originalText);
    $(enablingTargetId).removeClass('highlight');
  }
}

page.on('ready turbo:load turbo:frame-load', () =>
  $('.js-conditional-text').each(function (i, node) {
    const conditionTarget = '#' + $(node).attr('id');
    jsRewriteTextCheck(conditionTarget);
  })
);

page.on('change', '.js-conditional-text-target', function (e) {
  const enablingTarget = $(e.target).data('conditional-text');
  jsRewriteTextCheck(enablingTarget);
});

page.on('click tap', '[data-focus]', function (e) {
  e.preventDefault();
  const element = $(e.target);
  const focus = $(`#${element.data('focus')}`);
  if (focus.is(':focus')) {
    focus.trigger('blur');
  } else {
    focus.trigger('focus');
  }
});

page.on('change', ".js-filterScale input[type='checkbox']", function () {
  const checkbox = $(this).closest('.filterSidebar-line');
  checkbox.nextAll().find("input[type='checkbox']").prop('checked', false);
  checkbox.prevAll().find("input[type='checkbox']").prop('checked', true);
  checkbox.closest('form').submit();
});

page.on('ready turbo:render turbo:frame-render', function () {
  $('[data-trigger]').each(function () {
    const element = $(this);
    const action = $(`#${element.data('trigger')}`);
    if (!element.hasClass('active')) {
      action.hide();
    }
  });
});

page.on('change', '[data-explanation-target]', function () {
  const select = $(this);
  const target = $(select.data('explanation-target'));
  const option = select.find(`[value='${select.val()}']`);
  const content = option.data('explanation');
  target.html(content || '');
});

let previewImageClass = 'input-image-preview';
page.on(
  'change',
  "input[type='file'][data-preview-container]",
  function (this: HTMLInputElement) {
    const container = document.querySelector(this.dataset.previewContainer!)!;
    const wrapper = this.dataset.previewWrap;
    previewImageClass = 'input-image-preview';
    container
      .querySelectorAll('.' + previewImageClass)
      .forEach((el) => el.remove());

    for (const file of Array.from(this.files || [])) {
      const url = URL.createObjectURL(file);
      let node: HTMLElement;
      const img = document.createElement('img');
      img.src = url;
      if (wrapper) {
        const div = document.createElement('div');
        div.className = wrapper;
        div.appendChild(img);
        const close = document.createElement('div');
        close.className =
          previewImageClass + ' ' + previewImageClass + '__remove';
        div.appendChild(close);
        node = div;
      } else {
        node = img;
      }
      node.className += ' ' + previewImageClass;
      const lastChild = container.children[container.children.length - 1];
      container.insertBefore(node, lastChild);
    }
  }
);

page.on('click', '.input-image-preview__remove', function () {
  const container = $(this).parent().parent();
  const input = container.find("input[type='file']");
  input.val('');
  container.find('.' + previewImageClass).remove();
});
